module.exports = __webpack_public_path__ + "static/media/smsMessage.255c67de.txt";